module.exports = __webpack_public_path__ + "f07f4397e750215ceac071a1eb2178b9.png";